import { StatusCodes } from 'http-status-codes';
import Toast from 'react-native-toast-message';

import { b64ToBlob } from '../../../src/imageUtils';
import bodySitesActions from '../../../store/actions/bodySitesActions';
import { TOAST_TYPES } from '../../../constants/UIConstants';
import codes from '../../../constants/codeableConcepts';

export const bodySiteCanvasSave = async ({
	condition,
	frontCanvasData,
	backCanvasData,
	frontData,
	backData,
	tbsaFormula,
	fluidResuscitationFormula,
	dispatch,
	onClose,
}) => {
	const frontBlob = await b64ToBlob(frontCanvasData);
	const backBlob = await b64ToBlob(backCanvasData);
	const res = await dispatch(bodySitesActions.create(
		condition.eocId,
		condition.conditionId,
		frontBlob,
		backBlob,
		frontData.tbsa,
		backData.tbsa,
		frontData.bodySites,
		backData.bodySites,
		tbsaFormula && tbsaFormula.code ? tbsaFormula.code : codes.tbsaFormulas.mosteller.code,
		fluidResuscitationFormula && fluidResuscitationFormula.code ? fluidResuscitationFormula.code : codes.fluidResuscitationFormulas.parkland.code
	));

	Toast.show({
		type: res.status === StatusCodes.OK ? TOAST_TYPES.success : TOAST_TYPES.error,
		text1: res.status === StatusCodes.OK ? 'Success! Canvas added' : 'Error adding canvas record',
	});
	if(res.status === StatusCodes.OK) onClose();
};

export const bodySiteCanvasUpdate = async ({
	bodySite,
	frontCanvasData,
	backCanvasData,
	frontData,
	backData,
	tbsaFormula,
	fluidResuscitationFormula,
	dispatch,
	onClose,
}) => {
	const localTbsaFormula = (tbsaFormula && tbsaFormula.code) ? tbsaFormula.code
		: (bodySite && bodySite.tbsaFormula) ? bodySite.tbsaFormula
			: codes.tbsaFormulas.mosteller.code;
	const localFluidResuscitationFormula = (fluidResuscitationFormula && fluidResuscitationFormula.code) ? fluidResuscitationFormula.code
		: (bodySite && bodySite.fluidResuscitationFormula) ? bodySite.fluidResuscitationFormula
			: codes.fluidResuscitationFormulas.parkland.code;

	const frontBlob = await b64ToBlob(frontCanvasData);
	const backBlob = await b64ToBlob(backCanvasData);
	const res = await dispatch(bodySitesActions.update(
		bodySite.eocId,
		bodySite.conditionId,
		bodySite.bodySiteId,
		frontBlob,
		backBlob,
		frontData.tbsa,
		backData.tbsa,
		frontData.bodySites,
		backData.bodySites,
		localTbsaFormula,
		localFluidResuscitationFormula,
	));

	Toast.show({
		type: res.status === StatusCodes.OK ? TOAST_TYPES.success : TOAST_TYPES.error,
		text1: res.status === StatusCodes.OK ? 'Success! Canvas added' : 'Error adding canvas record',
	});
	if(res.status === StatusCodes.OK) onClose();
};

export const bodySiteCanvasDims = {
	width: 343,
	height: 706,
	buttonContainerScale: 3,
	footerHeight: 60,
	canvasPadding: 20,
};

export const detectIsFront = (bodySite) => {
	let isFrontData = false;
	Object.keys(bodySite.tbsaDataFront).map((severityKey) => {
		if (bodySite.tbsaDataFront[severityKey] > 0) isFrontData = true;
	});
	return isFrontData;
};